/**
 * =========================================================
 * LEKONAS TESTIMONIALS PRO
 * File: assets/lekonas-testimonials-pro.js
 * =========================================================
 */

(() => {
  const SELECTOR = "[data-testimonials-section]";

  function init(section) {
    if (!section || section.dataset.lkTestimonialsInit === "true") return;
    section.dataset.lkTestimonialsInit = "true";

    const track = section.querySelector("[data-testimonials-track]");
    const prev = section.querySelector("[data-testimonials-prev]");
    const next = section.querySelector("[data-testimonials-next]");
    const current = section.querySelector("[data-testimonials-current]");

    if (!track) return;

    const slides = () => [...track.querySelectorAll("[data-testimonial-slide]")];

    function slideWidth() {
      const first = slides()[0];
      if (!first) return 0;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return first.getBoundingClientRect().width + gap;
    }

    function index() {
      const w = slideWidth();
      if (!w) return 0;
      return Math.round(track.scrollLeft / w);
    }

    function update() {
      const total = slides().length;
      const i = index();

      if (current) current.textContent = String(i + 1);

      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= total - 1;
    }

    function go(dir) {
      track.scrollBy({
        left: slideWidth() * dir,
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
      });
    }

    if (prev) prev.addEventListener("click", () => go(-1));
    if (next) next.addEventListener("click", () => go(1));

    let timer;
    track.addEventListener(
      "scroll",
      () => {
        clearTimeout(timer);
        timer = setTimeout(update, 70);
      },
      { passive: true }
    );

    window.addEventListener("resize", update);
    update();

    const autoplay = section.dataset.autoplay === "true";
    const delay = parseInt(section.dataset.autoplaySpeed || "5000", 10);

    if (autoplay && slides().length > 1) {
      let interval;

      const start = () => {
        stop();
        interval = setInterval(() => {
          const total = slides().length;
          let i = index() + 1;
          if (i >= total) i = 0;

          track.scrollTo({
            left: slideWidth() * i,
            behavior: "smooth",
          });
        }, delay);
      };

      const stop = () => {
        if (interval) clearInterval(interval);
      };

      section.addEventListener("mouseenter", stop);
      section.addEventListener("mouseleave", start);
      section.addEventListener("touchstart", stop, { passive: true });
      section.addEventListener("touchend", start);

      start();
    }
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (e) => {
    const el = document.getElementById("shopify-section-" + e.detail.sectionId);
    if (el) {
      el.querySelectorAll(SELECTOR).forEach((s) => {
        s.dataset.lkTestimonialsInit = "false";
        init(s);
      });
    }
  });
})();
